export default __webpack_public_path__ + "public/assets/images/fe663f5871f78e528b695c3f0a883f7b.png";